<div class="preloader" [@preloaderActivate]="isActive ? 'active' : 'inactive'">
  <mat-progress-bar [mode]="'indeterminate'" class="preloader-progbar">
  </mat-progress-bar>
  <div class="preloader-text">
    {{mostRecent}}
  </div>
</div>
